import { useDialog } from '@globals/dialog/useDialogStore'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import BottomDrawer from '@shared/dialog/BottomDrawer'
import { T } from '@transifex/react'
import { ReactNode } from 'react'

type PWAInstallationModalProps = {
  dialogKey: string
  listItem1: ReactNode
  listItem2: ReactNode
}

const PWAInstallationModal: React.FC<PWAInstallationModalProps> = ({
  dialogKey,
  listItem1,
  listItem2,
}) => {
  const { closeDialog } = useDialog(dialogKey)

  return (
    <BottomDrawer drawerKey={dialogKey} title={<T _str="Add to home screen" />}>
      <List>
        <ListItem disablePadding>{listItem1}</ListItem>
        <br />
        <ListItem disablePadding>{listItem2}</ListItem>
      </List>
      <Button variant="outlined" fullWidth onClick={closeDialog} id="btnCloseIosInstallPrompt">
        <T _str="Close" />
      </Button>
    </BottomDrawer>
  )
}

export default PWAInstallationModal
